import { useState, useEffect, useCallback } from 'react';

interface GradientColors {
  start: string;
  end: string;
}

// Updated to more vibrant colors
const initialColors: GradientColors = {
  start: '#00f2fe', // Brighter cyan
  end: '#ff66ff'    // Brighter pink
};

export function useGradientAnimation() {
  const [gradientStyle, setGradientStyle] = useState({
    background: `linear-gradient(45deg, ${initialColors.start}, ${initialColors.end})`,
    backgroundSize: '400% 400%',
    animation: 'gradientAnimation 15s ease infinite'
  });

  const updateGradient = useCallback((colors: GradientColors) => {
    setGradientStyle({
      background: `linear-gradient(45deg, ${colors.start}, ${colors.end})`,
      backgroundSize: '400% 400%',
      animation: 'gradientAnimation 15s ease infinite'
    });
  }, []);

  useEffect(() => {
    // Add keyframes to the document if they don't exist
    if (!document.querySelector('#gradient-keyframes')) {
      const style = document.createElement('style');
      style.id = 'gradient-keyframes';
      style.textContent = `
        @keyframes gradientAnimation {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Optional: Add color transition logic here
    const interval = setInterval(() => {
      updateGradient({
        start: initialColors.start,
        end: initialColors.end
      });
    }, 15000);

    return () => {
      clearInterval(interval);
      const style = document.querySelector('#gradient-keyframes');
      if (style) {
        style.remove();
      }
    };
  }, [updateGradient]);

  return gradientStyle;
}